export default function initInputFile(): void {
    const $inputFile = document.querySelectorAll<HTMLElement>('.js-input-file');
    $inputFile.forEach($container => {
        new InputFile($container);
    });
}

class InputFile {
    $el: HTMLElement;
    $input: HTMLInputElement | null;
    $fileName: HTMLElement | null;
    $deleteButton: HTMLElement | null;
    initialText: string;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$input = this.$el.querySelector('input[type="file"]');
        this.$fileName = this.$el.querySelector('.js-file-name');
        this.$deleteButton = this.$el.querySelector('.js-file-delete');
        this.initialText = this.$fileName?.dataset.initialText || '';
        
        this.init();
    }

    init(): void {
        if (!this.$input || !this.$fileName || !this.$deleteButton) return;

        // Écouter le changement de fichier
        this.$input.addEventListener('change', this.handleFileChange.bind(this));

        // Écouter le clic sur le bouton de suppression
        this.$deleteButton.addEventListener('click', this.handleDelete.bind(this));

        // Réinitialiser après envoi du formulaire
        document.addEventListener('wpcf7mailsent', this.resetInput.bind(this));
    }

    handleFileChange(): void {
        if (!this.$input || !this.$fileName || !this.$deleteButton) return;

        const file = this.$input.files?.[0];
        
        if (file) {
            // Attendre un peu que wpcf7 mette à jour les classes
            setTimeout(() => {
                if (!this.$input || !this.$fileName || !this.$deleteButton) return;
                
                // Vérifier si le fichier a des erreurs (via wpcf7) après le délai
                const hasError = this.$input.classList.contains('wpcf7-not-valid');
                
                if (!hasError) {
                    // Afficher le nom du fichier
                    this.$fileName.textContent = file.name;
                    // Afficher le bouton de suppression
                    this.$deleteButton.classList.remove('hidden');
                } else {
                    // En cas d'erreur, réinitialiser
                    this.resetInput();
                }
            }, 100);
        } else {
            this.resetInput();
        }
    }

    handleDelete(): void {
        if (!this.$input) return;
        
        this.resetInput();
    }

    resetInput(): void {
        // Vider l'input file
        if (this.$input) {
            this.$input.value = '';
        }

        if (!this.$fileName || !this.$deleteButton) return;

        // Remettre le texte initial
        this.$fileName.textContent = this.initialText;
        // Cacher le bouton de suppression
        this.$deleteButton.classList.add('hidden');
    }
}
